export const EMPLOYEE_PIN_PATH = '/univ_timeclock';
export const clockInToShiftPath = id => `/shifts/${id}/clock_in`;
export const clockInToUnscheduledShiftPath = id => `/jobs/${id}/clock_in`;
export const clockInBreakPath = id => `/shifts/${id}/clock_in_break`;
export const clockOutFromShiftPath = id => `/shifts/${id}/clock_out`;
export const clockOutFromBreakPath = id => `/shifts/${id}/clock_out_break`;
